const KEY = 'tracon_token';

export function getToken() {
  return localStorage.getItem(KEY);
}

export function setToken(token) {
  localStorage.setItem(KEY, token);
}

export function clearToken() {
  localStorage.removeItem(KEY);
}

export function isAuthenticated() {
  return !!getToken();
}

// Decode the JWT payload (base64url) WITHOUT verifying the signature.
// The server is the trust boundary; this is audit/attribution metadata
// only (e.g. stamping who initiated a renewal in the activity log).
// Never gate behavior on this client-side — it's display-grade only.
export function decodeToken() {
  const token = getToken();
  if (!token) return null;
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function getBrokerEmail() {
  const claims = decodeToken();
  return typeof claims?.email === 'string' ? claims.email : null;
}

// V1.5+ — WebAuthn / Face ID stubs. Not wired yet.
export async function subscribeToPush() {
  return null;
}
